export const docsHref = (path?: string): string => {
  const root = path?.startsWith("http") ? "" : "https://mondoo.com/docs";

  return path ? `${root}${path}` : root;
};
